const closeGridController = gridId => (dispatch) => {
  dispatch({type: 'CLOSE_GRID', payload: gridId})
}

export {
  closeGridController
}